import { ENDPOINTS } from 'shared/constants';
import {
  AppUser,
  FinishSessionResponse,
  GetBotResponse,
  GetSettingsResponse,
  StartSessionResponse,
  BoosterType,
} from 'shared/types';
import { httpClientAuthorized } from '../httpClient';
import { AxiosRequestConfig } from 'axios';

export const startSession = async () => {
  return await httpClientAuthorized.post<StartSessionResponse>(ENDPOINTS.START_SESSION);
};

export const finishSession = async (
  session_id: string,
  loot: number,
  degradation: number,
  failed_loot: number,
) => {
  return await httpClientAuthorized.put<FinishSessionResponse>(
    ENDPOINTS.FINISH_SESSION(session_id),
    {
      loot,
      degradation,
      failed_loot,
    },
  );
};

export const getSettings = async () => {
  return await httpClientAuthorized.get<GetSettingsResponse>(ENDPOINTS.GET_SETTINGS);
};

export const getCurrentTimeUTC = async (props?: AxiosRequestConfig) => {
  try {
    const res = await httpClientAuthorized.get<{ now: string }>(ENDPOINTS.CURRENT_TIME, props);
    return { currentTimeUTC: res.data.now, currentTimestampUTC: new Date(res.data.now).getTime() };
  } catch (error) {
    console.log(error);
    return {
      currentTimeUTC: new Date().toUTCString(),
      currentTimestampUTC: new Date().getTime(),
    };
  }
};

export const updateBonusLimit = async () => {
  const res = await httpClientAuthorized.post<AppUser>(ENDPOINTS.BONUS_LIMIT);
  return res.data;
};

export const addBonusSkipWaiting = async () => {
  const res = await httpClientAuthorized.post<AppUser>(ENDPOINTS.SKIP_WAITING);
  return res.data;
};

export const fetchBotInfo = async () => {
  const res = await httpClientAuthorized.get<GetBotResponse>(ENDPOINTS.BOT);
  return res.data;
};

export const skipWaitingOnce = async () => {
  const res = await httpClientAuthorized.get<AppUser>(ENDPOINTS.SKIP_WAITING_ONCE);
  return res.data;
};

export const buyBonusLimitOnce = async () => {
  const res = await httpClientAuthorized.get<AppUser>(ENDPOINTS.BUY_BONUS_LIMIT_ONCE);
  return res.data;
};

export const buyBooster = async (boosterType: BoosterType) => {
  const res = await httpClientAuthorized.post<AppUser>(ENDPOINTS.BUY_BOOSTER, {
    booster_type: boosterType,
  });
  return res.data;
};

export const activateBooster = async (boosterType: BoosterType) => {
  const res = await httpClientAuthorized.post<AppUser>(ENDPOINTS.ACTIVATE_BOOSTER, {
    booster_type: boosterType,
  });
  return res.data;
};
